import { Component } from '@angular/core';

import { Meta } from "@angular/platform-browser";

import { ModuleRegistry } from '@ag-grid-community/core';
// import 'ag-grid-enterprise';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { SideBarModule } from '@ag-grid-enterprise/side-bar';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { IDateFilterParams } from '@ag-grid-community/core';
ModuleRegistry.registerModules([ClientSideRowModelModule,ColumnsToolPanelModule,FiltersToolPanelModule,SetFilterModule,ExcelExportModule, SideBarModule,RowGroupingModule, MenuModule, ClipboardModule]);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {
  title = 'notifications';

  ishistoryView:boolean = false;
  
  constructor(private meta:Meta) {

  }

  
}


// const today = new Date();
// const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
export var datefilterParams: IDateFilterParams = {
  minValidYear: 1900,
  maxValidYear: 2100,
  comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
    var dateAsString = cellValue;
    if (dateAsString == null) return -1;

    dateAsString = dateAsString.substring(0,10);
    var dateParts = dateAsString.split('-');
    var cellDate = new Date(
      Number(dateParts[0]),
      Number(dateParts[1]) - 1,
      Number(dateParts[2])
    );
    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }
    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
};

